'use client';

import {createContext, useContext, ReactNode} from 'react';
import { resolveLabel } from '@/app/_lib/locale-utils';

export type GlobalLabels = Record<string, string>;

const LabelsContext = createContext<GlobalLabels>({});

export interface LabelsProviderProps {
    children: ReactNode;
    labels: GlobalLabels;
}

export function LabelsProvider({children, labels}: LabelsProviderProps) {
    return (
        <LabelsContext.Provider value={labels}>
            {children}
        </LabelsContext.Provider>
    );
}

export function useLabels(): GlobalLabels {
    return useContext(LabelsContext);
}

export function useLabel(key: string, fallback?: string): string {
    const labels = useContext(LabelsContext);
    return resolveLabel(labels, key, fallback);
}
